import React from "react";
import ReactEcharts from "echarts-for-react";
import {
  formatCurrency,
  formatCurrencyShort,
  formatInteger,
  installmentLabel,
} from "./dashboardFormat";

// Parcelamento no cartão: quanto de receita entrou em cada número de parcelas.
//
// Só cartão — parcela em Pix, boleto e cortesia é sempre 1, e misturá-las faria
// o "1x" parecer uma escolha de quem comprou. É o gráfico que diz quando o
// dinheiro entra de fato: 12x fecha bem depois do evento.

export default function InstallmentsChart({ installments = [] }) {
  if (installments.length === 0) {
    return (
      <div className="text-center text-muted py-5">
        Nenhuma venda paga no cartão de crédito.
      </div>
    );
  }

  const options = {
    grid: { left: 70, right: 20, top: 24, bottom: 36 },
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: (params) => {
        const point = params?.[0];
        if (!point) return "";
        const row = installments[point.dataIndex] ?? {};
        return [
          `<strong>${installmentLabel(row.installments)}</strong>`,
          formatCurrency(row.amount),
          `${formatInteger(row.transactions)} transação(ões)`,
        ].join("<br/>");
      },
    },
    xAxis: {
      type: "category",
      data: installments.map((row) => installmentLabel(row.installments)),
      axisLine: { lineStyle: { color: "#e2e6ef" } },
      axisTick: { show: false },
      axisLabel: { color: "#74788d", fontSize: 11 },
    },
    yAxis: {
      type: "value",
      splitLine: { lineStyle: { color: "#eff2f7" } },
      axisLabel: {
        color: "#74788d",
        fontSize: 11,
        // Explícito: o eixo de valor é lido de baixo para cima comparando as
        // casas, e isso só funciona com os números terminando na mesma coluna.
        align: "right",
        formatter: (value) => formatCurrencyShort(value),
      },
    },
    series: [
      {
        name: "Receita no cartão",
        type: "bar",
        data: installments.map((row) => row.amount),
        barMaxWidth: 46,
        itemStyle: { color: "#7b3294", borderRadius: [4, 4, 0, 0] },
      },
    ],
  };

  return <ReactEcharts option={options} style={{ width: "100%", height: "260px" }} />;
}
